import "./ImagesView.scss";

import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { baseUrl } from "../../../utils/apiData";

const ImagesView = ({ dataList }) => {
  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  return (
    <section className="images_preview p_bottom">
      <div className="content_wrap">
        <div className="btns">
          <button type="button" onClick={handlePrev}>
            <FaAngleLeft />
          </button>
          <button type="button" onClick={handleNext}>
            <FaAngleRight />
          </button>
        </div>
        <div className="img_slider_wrap">
          <Swiper
            spaceBetween={16}
            slidesPerView={3}
            loop={true}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            
            breakpoints={{
              1100: { slidesPerView: 3 },
              600: { slidesPerView: 2 },
              100: { slidesPerView: 1 },
            }}
          >
            {dataList?.map((data, k) => {
              return (
                <SwiperSlide key={k}>
                  <div className="images_slide">
                    <img src={`${baseUrl}/${data}`} alt="Preview" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ImagesView;
